<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="dddark rounded mb-5 infocontainer" style="margin-top: -10px;" v-show="noDataAvailable">
      <v-col cols="12">
        <span class="d-block pb-1 text-h6 text-center">{{$t('components.AIAutoDialerDashboard.NoData')}}</span>
      </v-col>
    </v-row>

    <v-row align="start" justify="space-between" class="dddark rounded" style="margin-top: -10px;">
      <v-col cols="auto">
        <span class="d-block pb-1 text-h6">{{$t('components.AIAutoDialerDashboard.Title')}} {{ this.clinic }}</span>
      </v-col>
      <v-col cols="auto" v-if="!isMobile">
        <v-btn
            outlined
            elevation="0"
            @click="downloadReport"
            :disabled="loading"
            style="margin-top: 1px; border-color: var(--v-ddgrey-base )">
          <v-icon color="ddgrey">mdi-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row id="ai_auto_dialer_report" class="ddblack">
      <v-col cols="12">
        <AIAutoDialerKPIs :kpis="data.kpis" :loading="loading"/>
      </v-col>
      <v-col cols="12">
        <DialsOverTimeChart :chartData="data.dials_statistics" :loading="loading"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import DataAPI from '@/utils/DataAPI';
import EventBus from '@/utils/EventBus';

import AIAutoDialerKPIs from "@/components/dashboard/aiAutoDialer/AIAutoDialerKPIs.vue";
import DialsOverTimeChart from "@/components/dashboard/aiAutoDialer/DialsOverTimeChart.vue";

/**
 * This component includes all the metrics and charts of the AI Auto Dialer dashboard.
 */

export default {
  name: 'AIAutoDialerDashboard',
  props: {
    initialClinic: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: true,
    clinic: "",
    noDataAvailable: false,
    data: {
      kpis: {
        total_dials: 0,
        unique_callers: 0,
      },
      dials_statistics: {
        by_month: {},
        by_month_accumulative: {},
        by_day_of_week: {},
        by_hour: {},
      }
    },
    dateFilter: {
      from: false,
      to: false
    },
    isMobile: false
  }),
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    await this.updateData(this.initialClinic);
  },
  methods: {
    async updateData(clinic = false, location = false) {
      console.log("Update AI Auto Dialer data");
      this.loading = true;
      this.data = await DataAPI.getAIAutoDialerData({ clinic, location });
      this.clinic = clinic;

      if (this.data.kpis.total_dials === 0) {
        this.noDataAvailable = true;
      }
      this.loading = false;
    },
    async downloadReport() {
      EventBus.$emit("popup", "Downloading...");
      const reportElement = document.getElementById('ai_auto_dialer_report');
      const filename = `${this.clinic}_ai_auto_dialer_stats.pdf`;
      const canvas = await html2canvas(reportElement);
      const img = canvas.toDataURL('image/png');

      const doc = new jsPDF({
        unit: 'px',
        format: [canvas.width, canvas.height],
        hotfixes: ["px_scaling"]
      });

      doc.addImage(img, 'PNG', 0, 0);
      doc.save(filename);
    },
    onResize() {
      this.isMobile = window.innerWidth < 1000;
    }
  },
  components: {
    AIAutoDialerKPIs,
    DialsOverTimeChart
  }
}
</script>